import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { RepresentanteDashboardComponent } from './representante-dashboard.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        RepresentanteDashboardComponent
    ],
    exports: [
        RepresentanteDashboardComponent
    ]
})
export class RepresentanteDashboardModule { }

